<template>
    <div class="overlay__container">
        <div class="overlay__bg" :class="get__type()"></div>
    </div>
</template>
<style lang="scss" scoped>

    .overlay__container{
        display: block;
        width: 100%;
        height: 100%;

        .overlay__bg{
            display: block;
            width: 100%;
            height: 100%;
            // background: url('/placeholders/overlays/water.png');
            // background: url('/placeholders/overlays/crystal.png');
            // background: url('/placeholders/overlays/solid.png');
            // background: url('/placeholders/overlays/leaves.png');
            background-repeat: repeat-y;

            &.type-1{
                background: url('/placeholders/overlays/water.webp');
                background-repeat: repeat-y;
                background-size: contain;
            }

            &.type-2{
                background: url('/placeholders/overlays/crystal.webp');
                background-repeat: repeat-y;
                background-size: contain;
            }

            &.type-3{
                background: url('/placeholders/overlays/solid.webp');
                background-repeat: repeat-y;
                background-size: contain;
            }

            &.type-4{
                background: url('/placeholders/overlays/leaves.webp');
                background-repeat: repeat-y;
                background-size: contain;
            }
        }

        img{
            // display: block;
            // height: 100%;
            // width: 100%;
        }
    }

</style>
<script>
    export default {
        data(){
            return {
                // text: "Vue3 component."
            }
        },
        props: ['overlay_type'],
        methods: {
            get__type(){
                return 'type-' + this.overlay_type;
            }
        }
    }
</script>